import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { journalReputationTypeList, publisherReputationTypeList, reachTypeList } from '@/module/Author/EditorialTeam';

import { authorSchema } from '@/core/components';

export const editorialTeamSchema = z.object({
  type: z.enum(['JOURNAL', 'PUBLISHER']),
  journalName: z.string().nullable(),
  publisherName: z.string().nullable(),
  journalReputation: z.enum(journalReputationTypeList).nullable(),
  publisherReputation: z.enum(publisherReputationTypeList).nullable(),
  reachType: z.enum(reachTypeList),
  startYear: z.number(),
  endYear: z.number().nullable(),
  authors: z.array(authorSchema).min(1),
});

export const defaultEditorialTeamValues: DefaultValues<EditorialTeamSchema> = {
  journalName: null,
  publisherName: null,
  journalReputation: null,
  publisherReputation: null,
  reachType: 'NATIONAL',
  endYear: null,
  authors: [],
};

export type EditorialTeamSchema = z.infer<typeof editorialTeamSchema>;
